module.exports = __webpack_public_path__ + "static/img/ad20.c4c3ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad20.png
// module id = kmli
// module chunks = 12